'use client';

import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { Dialog } from '../../../components/dialog';
import { InternalNetworkCopyableReadonlyField } from './InternalNetworkCopyableReadonlyField';
import type { InternalNetworkTunnelArtifactsDialogState } from './useInternalNetworkTunnelEnrollmentActions';

export type InternalNetworkTunnelArtifactsDialogProps = {
  dialog: InternalNetworkTunnelArtifactsDialogState | null;
  onClose: () => void;
};

export function InternalNetworkTunnelArtifactsDialog({
  dialog,
  onClose,
}: InternalNetworkTunnelArtifactsDialogProps) {
  const t = useTranslations('designSystem.networkSettings.internalConnection');
  const tCommon = useTranslations('designSystem.common');

  return (
    <Dialog
      open={dialog !== null}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      size="lg"
      title={dialog?.title ?? ''}
      description={t('tunnel.artifactsWarning')}
      closeLabel={tCommon('close')}
      primaryAction={{ label: t('done'), onClick: onClose }}
      dataTestid="internal-network-tunnel-artifacts-dialog"
      lazyMount
      unmountOnExit
    >
      {dialog ? (
        <VStack alignItems="stretch" gap={4} w="full">
          <InternalNetworkCopyableReadonlyField
            label={t('tunnel.routes')}
            value={dialog.artifacts.advertisedRoutes.join(', ')}
            rows={1}
            copyAriaLabel={tCommon('copy')}
          />
          <InternalNetworkCopyableReadonlyField
            label={t('tunnel.imageReference')}
            value={dialog.artifacts.artifacts.tailscaleImageReference}
            rows={1}
            copyAriaLabel={tCommon('copy')}
          />
          <InternalNetworkCopyableReadonlyField
            label={t('tunnel.deploymentCommand')}
            value={dialog.artifacts.artifacts.deploymentCommand}
            rows={1}
            copyAriaLabel={tCommon('copy')}
          />
          <InternalNetworkCopyableReadonlyField
            label={t('tunnel.composeYaml')}
            value={dialog.artifacts.artifacts.composeYaml}
            rows={16}
            minHeight="360px"
            copyAriaLabel={tCommon('copy')}
          />
        </VStack>
      ) : null}
    </Dialog>
  );
}
